import type { SelectCharactersAction } from "../types/action";
import { ALL_CHARACTERS } from "../types/character";
import type { ValidationResult } from "../types/common";
import type { HorrorRaceState } from "../types/game-state";

export function validateSelectCharacters(
  state: HorrorRaceState,
  action: SelectCharactersAction,
): ValidationResult {
  if (state.phase !== "SETUP_CHARACTER_SELECTION") {
    return { valid: false, error: "Not in character selection phase" };
  }

  const player = state.players.find((p) => p.id === action.playerId);
  if (!player) {
    return { valid: false, error: "Player not found" };
  }

  if (player.secretSelection !== null) {
    return { valid: false, error: "Player has already selected characters" };
  }

  if (action.characters.length !== 2) {
    return { valid: false, error: "Must select exactly 2 characters" };
  }

  if (action.characters[0] === action.characters[1]) {
    return { valid: false, error: "Must select 2 different characters" };
  }

  for (const character of action.characters) {
    if (!ALL_CHARACTERS.includes(character)) {
      return { valid: false, error: `Invalid character: ${character}` };
    }
  }

  return { valid: true };
}
